import { Component, computed, inject } from '@angular/core'
import { addressSharedUtil } from '@naturalcycles/shared'
import { SignalStore } from '@src/app/core/store/signalStore.js'

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  standalone: false,
})
export class UserDetailsComponent {
  store = inject(SignalStore)

  formattedShippingAddress = computed(() => {
    const { shippingAddress } = this.store.$account()
    if (shippingAddress) {
      return addressSharedUtil.formatAddress(shippingAddress, true)
    }
  })

  formattedBillingAddress = computed(() => {
    const { billingAddress } = this.store.$account()
    if (billingAddress) {
      return addressSharedUtil.formatAddress(billingAddress, true)
    }
  })

  protected requiresBillingAddress = computed(() => {
    const order = this.store.$order()
    const cart = this.store.$cart()

    if (order.cart && order.status) return !!order.cart.requiresBillingAddress
    return !!cart.requiresBillingAddress
  })

  protected requiresShippingAddress = computed(() => {
    const order = this.store.$order()
    const cart = this.store.$cart()

    if (order.cart && order.status) return !!order.cart.requiresShippingAddress
    return !!cart.requiresShippingAddress
  })
}
